import { useEffect, useState } from "react";

export const SECRET_URL = "https://acidtechnoradio.dance";

export const useSecret = () => {
  const [open, setOpen] = useState(false);
  const [raving, setRaving] = useState(false);
  const [hits, setHits] = useState(0);
  const reveal = () => { setOpen(true); setRaving(true); setHits((h) => h + 1); };

  useEffect(() => {
    if (!hits) return;
    const a = setTimeout(() => setOpen(false), 10000);
    const b = setTimeout(() => setRaving(false), 8000);
    return () => { clearTimeout(a); clearTimeout(b); };
  }, [hits]);

  return { open, raving, hits, reveal, close: () => setOpen(false), calm: () => { setOpen(false); setRaving(false); } };
};

export const SecretLink = ({ onClose }) => (
  <a className="secret-link" href={SECRET_URL} target="_blank" rel="noopener noreferrer" onClick={onClose} data-testid="secret-link">
    <span className="secret-kicker">you found it</span>
    <span className="secret-title">acid techno radio</span>
    <span className="secret-url">acidtechnoradio.dance ↗</span>
  </a>
);
